<div class="div-item" (click)="clickOnItem()">
  <ion-button fill="clear" color="black">
    @if (fontAwesomeName()) {
      <i aria-hidden="true" class="icons fa {{ fontAwesomeName() }}"></i>
    }

    @if (iconName()) {
      <ion-icon color="noir" name="{{ iconName() }}"></ion-icon>
    }

    @if (svgFileName()) {
      <img width="24" height="24" [src]="'assets/icon/' + svgFileName()" />
    }
  </ion-button>

  <span>{{ title() | translate }}</span>
</div>
